export const isNotEmptyIsNumber = (value: string) => {
  const realValue = value.trimEnd()
  if (!isNaN(Number(realValue)) && realValue.length !== 0) {
    return true
  }
  return false
}
